import { c as _c } from "react/compiler-runtime";
import { FormLabel, Hint, NotionEditor } from '@onefootprint/ui';
import { useId } from 'react';
import { agentBlockSlashCommands } from '../agent-blocks/agent-block-slash-commands';
import usePromptMentionExtensions from '../prompt-mention/use-prompt-mention-extensions';
type MarkdownFieldProps = {
  label: string;
  hint?: string;
  value: string;
  onChange: (markdown: string) => void;
  onBlur?: () => void;
  /** Node hosting this prompt; the @ menu only offers tasks/outputs that run before it. */
  mentionNodeId?: string;
};
const MarkdownField = t0 => {
  const $ = _c(17);
  const {
    label,
    hint,
    value,
    onChange,
    onBlur,
    mentionNodeId
  } = t0;
  const labelId = useId();
  const extensions = usePromptMentionExtensions(mentionNodeId);
  let t1;
  if ($[0] !== label || $[1] !== labelId) {
    t1 = <FormLabel id={labelId} size="compact">{label}</FormLabel>;
    $[0] = label;
    $[1] = labelId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== extensions || $[4] !== onBlur || $[5] !== onChange || $[6] !== value) {
    t2 = <NotionEditor content={value} onChange={onChange} onBlur={onBlur} emitOnMount={false} extensions={extensions} slashCommands={agentBlockSlashCommands} />;
    $[3] = extensions;
    $[4] = onBlur;
    $[5] = onChange;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== labelId || $[9] !== t2) {
    t3 = <div role="group" aria-labelledby={labelId} className={"\n          rounded-default border border-tertiary bg-primary px-3 py-2 min-h-[6rem]\n          focus-within:border-accent transition-colors\n          [&_.notion-editor]:text-body-3\n          [&_.notion-editor_h1]:py-1! [&_.notion-editor_h1]:text-heading-3\n          [&_.notion-editor_h2]:py-1! [&_.notion-editor_h2]:text-label-1\n          [&_.notion-editor_h3]:py-0.5! [&_.notion-editor_h3]:text-label-2\n          [&_.notion-editor_p]:my-0! [&_.notion-editor_p]:py-0!\n          [&_.notion-editor_p:not(:first-child)]:mt-2!\n        "}>{t2}</div>;
    $[8] = labelId;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== hint) {
    t4 = hint && <Hint>{hint}</Hint>;
    $[11] = hint;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div>{t1}{t3}{t4}</div>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default MarkdownField;